module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAA6klEQVQokWP0nPDLk4GBYS4DA4MkA3HgOQMDQzITiZoYoGrnMpGoCa6ZiViV3OwMDE4aCOVEaWRiZGCo8mJh0JRkJE1jpgMzw88//xmmH/iLqdFLl4lBgAtTU5gJE4O2FCNDz86/DP/+M2BqFORiYGgPYkHRbKHExOCtx8RQt/Evw7dfaM6HMZae/Mdw5PY/uGZ1CUaGAhdmhqbNfxnefPnPgA5YkPkgzSAA0szLwcgwYc9fhruvMTWBAIpGmGZ2VkaGLz/+MZy4BzGIKI0gMO8IIvRwAZAfQWmPVPACpDEFxCBB51MGBoZkAD61PEX3lH/LAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/img/check.png
// module id = bGMI
// module chunks = 1